import React from 'react';
import 'twin.macro';
import { ArrowRightIcon as ArrowRight } from '@heroicons/react/24/outline';
import { School } from 'types/school';
import { Schoolyear } from 'types/schoolyear';
import { isoDatePatternWithSlashes } from 'utils/time/datePatterns';
import { format } from 'utils/time/format';
import { Trans, useTranslation } from 'react-i18next';
import { UserLocale } from '@teetsh/app/src/types/user';
import { CahierJournalButtonLink } from 'containers/CahierJournal/CahierJournalButtonLink';
import { SchoolSchoolyearProvider } from 'containers/App/context/SchoolyearSchoolProvider';

interface Props {
  nbOfSpecificEventIdsSelected?: string[];
  newEventIds?: string[];
  targetDate: Date;
  school: School;
  schoolyear: Schoolyear;
  locale: UserLocale;
  view: string;
}

export function CopySuccessMessage({
  nbOfSpecificEventIdsSelected,
  newEventIds,
  targetDate,
  school,
  schoolyear,
  locale,
  view,
}: Props) {
  let item: 'day' | 'seances' | 'seance' = 'day';
  if ((nbOfSpecificEventIdsSelected || []).length > 1) {
    item = 'seances';
  }
  if ((nbOfSpecificEventIdsSelected || []).length === 1) {
    item = 'seance';
  }
  const { t } = useTranslation(['cahierJournal']);

  return (
    <>
      <p>
        <Trans
          i18nKey={`cahierJournal:messages.successfullyCopied.${item}`}
          values={{
            day: format(targetDate, locale, 'EEEE dd MMM'),
            schoolName: school.name,
            schoolyear: schoolyear.label,
          }}
        >
          La journée a bien été copiée vers le <strong>DAY</strong> de l'école
          <strong>SCHOOL</strong> (<strong>YEAR</strong>) 🥳
        </Trans>
      </p>

      <div tw="mt-3 flex justify-end">
        <SchoolSchoolyearProvider
          schoolyearId={schoolyear.id}
          schoolId={school.id}
        >
          <CahierJournalButtonLink
            to={`cahier-journal/${view}/${format(
              targetDate,
              locale,
              isoDatePatternWithSlashes,
            )}?highlight=${newEventIds?.join(',')}`}
            outlined
            intent="success"
          >
            {t('cahierJournal:actions.goToCopyDestination')}{' '}
            <ArrowRight tw="h-4 w-4 ml-2" />
          </CahierJournalButtonLink>
        </SchoolSchoolyearProvider>
      </div>
    </>
  );
}
